<form [formGroup]="formGroup">
  <!-- Name -->
  <mat-form-field>
    <mat-label>Display Name</mat-label>
    <input matInput required formControlName="name" />
  </mat-form-field>
</form>
